import React from 'react';

const medicationData = [
  {
    title: 'Tolvaptan',
    subtitle: 'Targets vasopressin pathway to slow cyst growth',
    points: [
      'Slows kidney enlargement and function decline',
      'For patients with high-risk progression',
      'Requires frequent urination monitoring',
      'Regular liver function tests needed',
      'Prescription requires specialist evaluation',
    ],
  },
  {
    title: 'RAAS Inhibitors (ACE/ARB)',
    subtitle: 'Blood pressure control and kidney protection',
    points: [
      'First-line treatment for blood pressure',
      'Reduces protein in urine (proteinuria)',
      'Provides cardiovascular protection',
      'Slows kidney function decline',
      'Generally well-tolerated',
    ],
  },
  {
    title: 'Other Medicines',
    subtitle: 'Supporting treatments for PKD complications',
    points: [
      'Kidney-safe pain management options',
      'Antibiotics for urinary tract infections',
      'Medications for cardiovascular complications',
      'Treatments for kidney stone prevention',
      'Always consult about kidney safety',
    ],
  },
];

const Medication = () => {
  return (
    <section className="section medication-section">
      <div className="container">
        <h2 className="section-title">Medication in PKD</h2>
        <div className="grid-container">
          {medicationData.map((med, index) => (
            <div className="info-card" key={index}>
              <h3 className="card-title">{med.title}</h3>
              <p className="card-description">{med.subtitle}</p>
              <ul>
                {med.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Medication;